import React, { Component } from 'react'
import {
  Table,
  Input,
  Popconfirm,
  Button,
  AutoComplete,
  Icon,
  Progress,
  Modal,
  Radio,
  Form
} from 'antd'
import _ from 'lodash'
import styled from 'styled-components'

import { convertToOption } from '../../util'
// styled components
const AddItemArea = styled.div`
  padding-top: 10px;
  padding-right: 10px;
`
const { Column } = Table
const FormItem = Form.Item
const ButtonGroup = Button.Group
const EditableCell = ({ editable, value, onChange }) => (
  <div>
    {editable ? (
      <Input style={{ margin: '-5px 0' }} value={value} onChange={e => onChange(e.target.value)} />
    ) : (
      value
    )}
  </div>
)

class ChangeOrderView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalVisible: false,
      tastName: '',
      taskType: 'Construction'
    }
  }
  handleCheckboxChange = event => {
    console.log('event', event.target.name)
    console.log('event', event.target.checked)
  }

  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.isEditingRow}
        value={text}
        onChange={value => this.props.handleInputChange(value, record.id, column)}
      />
    )
  }

  calcTaskDonePercentage = tasks => {
    if (tasks.length > 0) {
      const completedCount = tasks.filter(task => task.completed === 1)
      return parseInt((completedCount.length * 100 / tasks.length).toFixed(2), 0)
    } else {
      return 0
    }
  }

  handleTaskNameBlur = value => {
    if (value !== '')
      this.setState({
        modalVisible: _.findIndex(this.props.allTasks, { name: value }) < 0,
        taskName: value
      })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({
      modalVisible: false
    })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.handleQuickAddTask({
        name: values.name,
        type: values.type
      })

      this.setState({ modalVisible: false })
    })
  }

  handleTaskKeyPress = event => {
    this.setState({
      taskName: event.target.value
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { handleItemUp, handleItemDown } = this.props
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="Quick Add Task"
          okText={'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width={800}
          maskClosable={false}
        >
          <Form layout="vertical">
            <h6>The task you entered does not exist. Would you like to add it?</h6>
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Name">
                  {getFieldDecorator('name', {
                    rules: [
                      {
                        required: true,
                        message: 'Task name cannot be blank.'
                      }
                    ],
                    initialValue: this.state.taskName
                  })(<Input onChange={this.handleQuickAddTaskName} />)}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="Type">
                  {getFieldDecorator('type', {
                    rules: [
                      {
                        required: true,
                        message: 'Type cannot be blank.'
                      }
                    ],
                    initialValue: ''
                  })(
                    <Radio.Group onChange={this.handleQuickAddTypeChange}>
                      <Radio.Button value="Construction">Construction</Radio.Button>
                      <Radio.Button value="Adjuster">Adjuster</Radio.Button>
                    </Radio.Group>
                  )}
                </FormItem>
              </div>
            </div>
          </Form>
        </Modal>
        <Progress percent={this.calcTaskDonePercentage(this.props.serviceOrderItems)} />
        <Table
          dataSource={this.props.serviceOrderItems}
          size="small"
          bordered
          title={() => 'Service Order'}
          pagination={false}
          rowKey="id"
        >
          <Column
            title="Task"
            dataIndex="task_name"
            key="task_name"
            width={350}
            render={(text, record) => this.renderColumns(text, record, 'task_name')}
          />
          <Column
            title="Device #"
            dataIndex="device_number"
            key="device_number"
            render={(text, record) => this.renderColumns(text, record, 'device_number')}
          />
          <Column
            title="Notes"
            dataIndex="notes"
            key="notes"
            render={(text, record) => this.renderColumns(text, record, 'notes')}
          />
          <Column
            title="Materials Needed"
            dataIndex="materials_needed"
            key="materials_needed"
            render={(text, record) => this.renderColumns(text, record, 'materials_needed')}
          />
          <Column
            title=" "
            dataIndex="action"
            key="action"
            render={(text, record) => {
              if (this.props.isNew)
                return (
                  <div>
                    {record.isEditingRow && (
                      <Button icon="save" onClick={() => this.props.saveRow(record.id)} />
                    )}
                    {!record.isEditingRow && (
                      <Button icon="edit" onClick={() => this.props.editRow(record.id)} />
                    )}
                    <Popconfirm
                      title="Are you sure you want to delete this line?"
                      onConfirm={() => this.props.deleteRow(record.id)}
                      onCancel={this.cancelDelete}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button className="marginLeft5" type="danger" icon="delete" />
                    </Popconfirm>
                  </div>
                )
              return (
                <div>
                  {record.completed === 1 && (
                    <div className="textAlignCenter">
                      <Icon type="check-circle-o" /> Completed
                    </div>
                  )}
                  {(!record.completed || record.completed === 0) && (
                    <Button
                      icon="check-circle-o"
                      onClick={() => this.props.markTaskComplete(record.id)}
                    >
                      Mark as Complete
                    </Button>
                  )}
                </div>
              )
            }}
            width={120}
          />
          <Column
            title=" "
            dataIndex="actions"
            key="actions"
            width={150}
            render={(text, record) => (
              <div>
                <ButtonGroup>
                  <Button type="primary" onClick={() => handleItemDown(record.id)} icon="down" />
                  <Button type="primary" onClick={() => handleItemUp(record.id)} icon="up" />
                  {!this.props.isNew &&
                    record.isEditingRow && (
                      <Button icon="save" onClick={() => this.props.saveRow(record.id)} />
                    )}
                  {!this.props.isNew &&
                    !record.isEditingRow && (
                      <Button icon="edit" onClick={() => this.props.editRow(record.id)} />
                    )}
                  {!this.props.isNew && (
                    <Popconfirm
                      title="Are you sure you want to delete this line?"
                      onConfirm={() => this.props.deleteRow(record.id)}
                      onCancel={this.cancelDelete}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button className="marginLeft5" type="danger" icon="delete" />
                    </Popconfirm>
                  )}
                </ButtonGroup>
              </div>
            )}
          />
        </Table>
        {
          <AddItemArea>
            <div className="row">
              <div className="col-md-3">
                <AutoComplete
                  dataSource={convertToOption(this.props.allTasks)}
                  filterOption={(inputValue, option) =>
                    option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                  }
                  onBlur={this.handleTaskNameBlur}
                  placeholder="Search for a task..."
                  onChange={event => this.props.handleAddTaskInputChange(event)}
                  defaultValue={this.props.addTaskName}
                  value={this.props.addTaskName}
                >
                  <Input
                    onKeyPress={this.handleTaskKeyPress}
                    suffix={<Icon type="search" className="certain-category-icon" />}
                  />
                </AutoComplete>
              </div>
              <div className="col-md-2">
                <Input
                  placeholder="Type in device #..."
                  value={this.props.addDeviceNumberInput}
                  onChange={event =>
                    this.props.handleAddDeviceNumberInputChange(event.target.value)
                  }
                />
              </div>
              <div className="col-md-2">
                <Input
                  placeholder="Type in notes..."
                  value={this.props.addNotesInput}
                  onChange={event => this.props.handleAddNotesInputChange(event.target.value)}
                />
              </div>
              <div className="col-md-3">
                <Input
                  placeholder="Type in any materials needed..."
                  value={this.props.addMaterialsNeededInput}
                  onChange={event =>
                    this.props.handleAddMaterialsNeededInputChange(event.target.value)
                  }
                />
              </div>
              <div className="col-md-2 text-right">
                <Button onClick={() => this.props.handleAddItemClick()}>Add Item</Button>
              </div>
            </div>
          </AddItemArea>
        }
        <br />
      </div>
    )
  }
}

export default Form.create()(ChangeOrderView)



// WEBPACK FOOTER //
// ./src/components/service_order/ServiceOrderView.js